import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['fieldsWrapper'];

  connect() {
    this.updateAllTermsValues({});
  }

  // Called when a new term is added via nested-form
  initProjectTermValues(event) {
    const { fieldset: term } = event?.detail || {};
    if (!term) return;

    // Initialize with zero values
    const fields = [
      'income_share', 'construction_bill', 'maintenance_bill_share',
      'salary_bill_share', 'platform_fee_bill_share',
      'capitalisation_bill_share', 'tax_bill_share'
    ];

    fields.forEach(field => {
      const input = term.querySelector(`input[id*='${field}']`);
      if (input && !input.value) input.value = '0.0';
    });

    this.updateAllTermsValues({});
  }

  // Recalculates all terms (called on every input change)
  updateAllTermsValues(event) {
    const terms = Array.from(
      this.element.querySelectorAll('div[data-nested-form-target="fieldsWrapper"]:not([data-destroyed="true"])')
    ).filter(term => {
      const style = window.getComputedStyle(term);
      return style.display !== 'none';
    });

    terms.forEach((term) => {
      if (term.dataset.isReadonly === "true") return;
      this.updateTotalAmountToPay(term);
    });
  }

  // Calculates total_amount_to_pay for a given term
  updateTotalAmountToPay(term) {
    const getValue = (field) => parseFloat(term.querySelector(`input[id*='${field}']`)?.value) || 0;

    const incomeShare = getValue('income_share');
    const constructionBill = getValue('construction_bill');
    const maintenanceBillShare = getValue('maintenance_bill_share');
    const salaryBillShare = getValue('salary_bill_share');
    const platformFeeBillShare = getValue('platform_fee_bill_share');
    const capitalisationBillShare = getValue('capitalisation_bill_share');
    const taxBillShare = getValue('tax_bill_share');

    const totalAmountToPay = incomeShare
      - constructionBill
      - maintenanceBillShare
      - salaryBillShare
      - platformFeeBillShare
      - capitalisationBillShare
      - taxBillShare;

    const totalAmountToPayEl = term.querySelector("input[id*='total_amount_to_pay']");
    if (!totalAmountToPayEl) return;

    totalAmountToPayEl.value = totalAmountToPay.toFixed(2);

    // Validate: total must be >= 0
    this.validateTotalAmount(totalAmountToPayEl, totalAmountToPay);
  }

  validateTotalAmount(totalAmountToPayEl, totalAmountToPay) {
    const errorParent = totalAmountToPayEl.closest('li');
    if (!errorParent) return;

    errorParent.querySelectorAll('p.inline-errors').forEach(el => el.remove());

    if (totalAmountToPay < 0) {
      errorParent.classList.add('error');
      const errorMessage = document.createElement('p');
      errorMessage.className = 'inline-errors';
      errorMessage.textContent = totalAmountToPayEl.dataset.onError;
      errorParent.appendChild(errorMessage);
      this.element.querySelector("input[type='submit']")?.setAttribute('disabled', 'true');
    } else {
      errorParent.classList.remove('error');
      this.element.querySelector("input[type='submit']")?.removeAttribute('disabled');
    }
  }
}
